<div class="d-flex align-items-center gap-4 py-4" *ngIf="!uploading">
  <div class="icon" style="width: 14em; height: 14em" [style.background-image]="'url(' + iconUrl + ')'"></div>
  <div class="icon" style="width: 10em; height: 10em" [style.background-image]="'url(' + iconUrl + ')'"></div>
  <div class="icon" style="width: 8em; height: 8em" [style.background-image]="'url(' + iconUrl + ')'"></div>
  <div class="icon" style="width: 5em; height: 5em" [style.background-image]="'url(' + iconUrl + ')'"></div>
  <div class="icon" style="width: 3em; height: 3em" [style.background-image]="'url(' + iconUrl + ')'"></div>
</div>
<app-file-upload
  [(uploadProgress)]="uploadProgress"
  [(uploading)]="uploading"
  [disabled]="false"
  (upload)="uploadIcon($event)"
  [fileTypes]="imageFormats"
  [confirm]="false"
  [multiple]="false"
  [buttonText]="'Change'"
  [icon]="'sync'"
></app-file-upload>
